import { textAnimation } from "../work-modules/041/App";
// import "../work-modules/005/textAnimation";
// import "../work-modules/005/controls";

const boot = () => {
  // 先に WebGL を起動してイベントリスナーを登録
  // その後、テキストアニメを開始（startイベントを確実に受け取る）
  textAnimation();

  // app 準備完了を通知（このページでは app インスタンスは存在しないため null）
  window.dispatchEvent(new CustomEvent("app:ready", { detail: { app: null } }));
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
